module.exports = __webpack_public_path__ + "img/shortlogo.081069e1.png";